import React, { FC, useContext, useEffect, useMemo, useState } from "react";

import { CATEGORY_LIST, CREATE_PRODUCT, PRODUCT_CREATE } from "../ProductConstants";
import ProductCategorySkeleton from "./ProductCategorySkeleton";
import { useHistory } from "react-router-dom";
import CustomSearchBar from "../components/CustomSearchBar";

import CategoryTypeItem from "./CategoryTypeItem";
import CategoryItem from "./CategoryItem";
import { ProductsContext, TcategoryData } from "../ProductsContext";
import { AppContext } from "Context/AppContext";
import { toast } from "react-toastify";

const ProductCategoryList: FC = () => {
  const appData = useContext(AppContext);
  const productContext = useContext(ProductsContext);
  const createPermission = appData.pm.checkPermission("gmsproducts_create");
  const history = useHistory();
  //const [categoryData, setCategoryData] = useState<CategoryType | undefined | null>([]);
  const [search, setSearch] = useState<string>("");

  // @todo
  const handleSearchChange = (term: string) => {
    setSearch(term);
  }

  useEffect(() => {
    if (!appData?.pm?.checkPermission("gmsproducts_read")) {
      history.push("/workspace/module/permission/denied");
      return;
    }
    if (productContext.categoryData.length !== 0) return;
    productContext.getCategoryTypeAndCategory();
  }, []);

  const categoriesToDisplay = productContext.categoryData.filter(categoryType => {
    return categoryType?.category.filter(((cat: any) => cat.name.toLowerCase().includes(search?.toLowerCase()))).length > 0
  })

  const isCategoryPresent = categoriesToDisplay.some((categoryType) => categoryType.category && categoryType.category.length > 0)

  const sortedCategories = useMemo(() =>
    categoriesToDisplay
      ? [...categoriesToDisplay].sort((a: TcategoryData, b: TcategoryData) =>
        a.name.localeCompare(b.name))
      : []
    , [categoriesToDisplay])

  return (
    <>
      <div className={`tw-px-[21px] tw-pt-[12px] tw-flex tw-justify-between`}>
        <div className={`tw-flex tw-flex-col tw-items-left tw-text-xs`}>
          <label className={`tw-text-black tw-text-xl tw-font-semibold tw-leading-[25.2px]`}>
            {CATEGORY_LIST}
          </label>
        </div>
        <div className={`tw-flex`}>
          <CustomSearchBar handleSearchChange={handleSearchChange} />

          <div className={`tw-ps-3`}>
            <button
              onClick={() => { if (createPermission) { history.push(PRODUCT_CREATE) } else { toast.info("You don't have permission to Create a Product") } }}
              className={`button-style tw-w-max`}
            >
              {CREATE_PRODUCT}
            </button>
          </div>
        </div>
      </div>
      <div className={`tw-ml-5 tw-mt-2 tw-box-border tw-w-auto tw-border-t-[1px] tw-border-solid tw-border-lightgray-200`} />
      {productContext.showLoader && (
        <>
          <ProductCategorySkeleton />
          <ProductCategorySkeleton />
        </>
      )}

      {
        !productContext.showLoader &&
          isCategoryPresent ?
          sortedCategories?.map((data: any, index: any) => {
            const categories = data?.category.filter(((cat: any) => cat.name.toLowerCase().includes(search?.toLowerCase())))

            if (categories.length <= 0) return <></>
            return (
              <React.Fragment key={data.name + index}>
                <CategoryTypeItem categoryTypename={data?.name} />
                <div className={`tw-flex tw-flex-wrap`}>
                  {categories?.map((category: any) => (
                    <React.Fragment key={category?.name}>
                      <CategoryItem categoryId={category?.id} categoryName={category?.name} />
                    </React.Fragment>
                  ))}
                </div>
              </React.Fragment>
            )
          })
          :
          <div className={`tw-flex-grow tw-min-h-min tw-inset-0 tw-flex tw-items-center tw-justify-center`}>
            {!productContext.showLoader ?
              <div className={`tw-text-center`}>
                <img className={`tw-w-auto tw-h-[100px]`} src={process.env.PUBLIC_URL + "/img/place_holder_no_data.svg"} alt="logo" />
                <label className={`tw-text-[24px] tw-text-[#091caa] tw-font-semibold`}>No Data Found</label>
              </div> : null}
          </div>
      }
    </>
  );
};

export default ProductCategoryList;
